export default {
	templateNameMissing: "Template must have a name.",
	templateCategoryInvalid: "Template must be assigned to a valid category or team.",
	templateContentMissing: "Template must have content.",
	teamIdMissing: "Template must be assigned to a team.",
	scopeMissing: "Template must have a team scope.",
};
